import { useState, useEffect } from "react";
import { Routes, Route } from 'react-router-dom'
// Import Pages
import Home from './pages/Home'
import Admin from "./pages/Admin";
import About from './pages/About'
import Contact from './pages/Contact'
import Support from './pages/Support'
import DonationPage from './pages/DonationForm'
import Projects from './pages/Projects'
import Events from './pages/Events'
import TripReport from './pages/TripReport'
//Import top-level components
import Navbar from "./components/Navbar";
import Video from "./components/Video";
import MobileFooter from "./components/MobileFooter";
//Import video array
import videoList from "./api/videoList";
//Import CSS
import "./styles/style.css";

export default function App() {
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [highlighterVisible, setHighlighterVisible] = useState(null);

  const showHighlighter = () => setHighlighterVisible(true);
  const fadeHighlighter = () => setHighlighterVisible(false);

  useEffect(() => {
    const rand = videoList[Math.floor(Math.random() * videoList.length)];
    setSelectedVideo(rand);
  }, []);

  return (
    <div className="main">
      <Navbar onLogoClick={showHighlighter} onPageClick={fadeHighlighter} />
      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="/about" element={<About />}></Route>
        <Route path="/projects" element={<Projects />}></Route>
        <Route path="/events" element={<Events />}></Route>
        <Route path="/support" element={<Support />}></Route>
        <Route path="/contact" element={<Contact />}></Route>
        <Route path="/donate" element={<DonationPage />}></Route>
        <Route path="/human-encounters" element={<TripReport />}></Route>
        <Route path="/admin" element={<Admin />}></Route>
      </Routes>
      <Video videoInfo={selectedVideo} highlighterVisible={highlighterVisible}></Video>
      <MobileFooter></MobileFooter>
    </div>
  )
}